import {useTranslation} from 'react-i18next';
import StatusLabel, {StatusColor} from '../StatusLabel/StatusLabel';
import {useEntranceStatus} from './useEntranceStatus';
import {EntranceState} from './entranceStatus.utils';
// import {formatCountdown} from '../../../library/dates'; // Countdown temporarily disabled

const stateConfig: Record<EntranceState, {color: StatusColor; textKey: string}> = {
    today: {color: 'highlight', textKey: 'statusToday'},
    countdown: {color: 'highlight', textKey: 'statusCountdown'},
    tomorrow: {color: 'brand', textKey: 'statusTomorrow'}
};

function EntranceTicketStatus() {
    const {t} = useTranslation('eTicket');
    const {state} = useEntranceStatus();
    if(!state)
        return null;

    const {color, textKey} = stateConfig[state];
    // Countdown temporarily disabled — showing only the text ("today"/"tomorrow"). To restore:
    // const text = state === 'countdown' ? `${t(textKey)} ${formatCountdown(remainingSec)}` : t(textKey);
    const text = t(textKey);

    return (
        <StatusLabel
            color={color}
            text={text}
            data-cy="entrance-ticket-status"
        />
    );
}

export default EntranceTicketStatus;
